import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import Navbar from "./Navbar";

const Layout = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "100%",
          flex: 1,
          paddingTop: { xs: "72px", md: "0px" },
        }}
      >
        <Navbar />
        <Outlet />
      </Box>
    </>
  );
};

export default Layout;
